import { Button, type ButtonProps } from "~/components/Button";
import { cn, type WithClassNameAndChildren } from "~/lib/utils";

const ScreenRoot = ({ children, className }: WithClassNameAndChildren) => {
  return (
    <div
      className={cn(
        "flex h-full flex-1 flex-col items-center justify-center bg-interface-neutral-2",
        className
      )}
    >
      {children}
    </div>
  );
};

const ScreenTopAction = ({ children, className }: WithClassNameAndChildren) => {
  return (
    <div className={cn("absolute left-12 top-12 z-10", className)}>
      {children}
    </div>
  );
};

const ScreenVisual = ({ children, className }: WithClassNameAndChildren) => {
  return <div className={className}>{children}</div>;
};

const ScreenContent = ({ children, className }: WithClassNameAndChildren) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-6 xl:gap-8",
        className
      )}
    >
      {children}
    </div>
  );
};

const ScreenBottomAction = ({
  children,
  className
}: WithClassNameAndChildren) => {
  return (
    <div
      className={cn(
        "absolute bottom-12 w-full flex justify-center items-center z-10",
        className
      )}
    >
      {children}
    </div>
  );
};

export const ScreenTitle = ({
  children,
  className
}: WithClassNameAndChildren) => {
  return (
    <p
      className={cn(
        "text-4xl font-semibold text-interface-neutral-6 md:text-5xl lg:text-6xl xl:text-7xl",
        className
      )}
    >
      {children}
    </p>
  );
};

export const ScreenText = ({
  children,
  className
}: WithClassNameAndChildren) => {
  return (
    <p
      className={cn(
        "text-center text-xl text-interface-neutral-5 md:text-2xl lg:text-3xl xl:text-4xl",
        className
      )}
    >
      {children}
    </p>
  );
};

export const ScreenButton = (props: ButtonProps) => {
  return <Button variant="primary-light" size="large" {...props} />;
};

// Namespace pattern export for base Screen component
export const Screen = Object.assign(ScreenRoot, {
  TopAction: ScreenTopAction,
  Visual: ScreenVisual,
  Content: ScreenContent,
  BottomAction: ScreenBottomAction,
  Title: ScreenTitle,
  Text: ScreenText,
  Button: ScreenButton
});
